import type { MetaDescriptor } from '@remix-run/node'

const SITE = 'https://quiveros.ai'
const DEFAULT_OG_IMAGE = `${SITE}/og-image.png`

/**
 * Full page meta + Open Graph + Twitter-card tags for a marketing surface, in
 * one place so every social unfurl is consistent (same image, same shape).
 * `ogTitle` / `ogDescription` default to `title` / `description` but can be a
 * punchier variant tuned for the card.
 */
export function marketingMeta({
  title,
  description,
  path,
  ogTitle,
  ogDescription,
  image = DEFAULT_OG_IMAGE,
}: {
  title: string
  description: string
  /** Absolute path for `og:url`, e.g. `/apps` or `/apps/real-estate`. */
  path: string
  ogTitle?: string
  ogDescription?: string
  image?: string
}): MetaDescriptor[] {
  return [
    { title },
    { name: 'description', content: description },
    { property: 'og:title', content: ogTitle ?? title },
    { property: 'og:description', content: ogDescription ?? description },
    { property: 'og:image', content: image },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: `${SITE}${path}` },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:image', content: image },
  ]
}
